//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ShopsListItem from "@/components/pages/storeFinder/ShopsList/Components/ShopsListItem";
import {mapGetters} from "vuex";

export default {
    name: "ShopsList",
    components: {ShopsListItem},
    props: {
        shops: {
            type: Array,
            default: () => { return [] }
        },
        activeId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            autocomplete: null,
            searchInput: '',
        }
    },
    computed: {
        ...mapGetters({
            hasMorePage: 'storefinder/hasMorePage',
        }),
    },
    methods: {
        chooseShop(item) {
            this.$emit('chooseShop', item);
        },
        getAddressData(data) {
            this.$emit('updateCoords', data)
        },
        getYourLocate() {
            this.$refs.autocomplete.value = '';
            this.$emit('getYourLocate')
        },
        loadMore() {
            this.$emit('loadMore');
        },
        initGoogleAutocomplete() {
            this.autocomplete = new google.maps.places.Autocomplete(
                (this.$refs.autocomplete),
                {types: ['geocode']}
            );
            this.autocomplete.addListener('place_changed', () => {
                let place = this.autocomplete.getPlace();
                this.searchInput = place.formatted_address;
                let coordinate = {
                    latitude: place.geometry.location.lat(),
                    longitude: place.geometry.location.lng(),
                }
                this.getAddressData(coordinate)
            });
        }
    },
    mounted() {
        setTimeout(function (){
            this.initGoogleAutocomplete()
        }.bind(this), 1000)
    }
}
